import { configureStore } from '@reduxjs/toolkit';
import { ApiSlice } from './ApiSice';
import { ChatSlice } from './ChatSlice';
import { HomeworkSlice } from './HomeworkSlice';
import { PostSlice } from './PostSlice';
import { StatusSlice } from './StatusSlice';

const store =  configureStore({
  reducer: {
    apiSlice: ApiSlice.reducer,
    chatSlice: ChatSlice.reducer,
    homeworkSlice: HomeworkSlice.reducer,
    postSlice: PostSlice.reducer,
    statusSlice: StatusSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: false,
        }),
})

export default store;
export type RootState = ReturnType<typeof store.getState>
